/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { PipelineEntityFilter } from './pipelineEntityFilter';
import type { PipelineFilterSchemaAddedWithin } from './pipelineFilterSchemaAddedWithin';
import type { PipelineFilterSchemaInStageWithin } from './pipelineFilterSchemaInStageWithin';
import type { PipelineFilterSchemaMinDegree } from './pipelineFilterSchemaMinDegree';

/**
 * Backend-evaluated filters for a job's pipeline candidates.
 *
 * Semantics: values *within* one field are OR-ed, fields are AND-ed together.
 * Every field defaults to ``None``, meaning "no constraint" — an all-default
 * instance matches the whole pipeline, identical to the unfiltered list.
 *
 * Each free-text field has an ``exclude_*`` companion holding the terms the
 * panel's chips marked as excluded. Exclusions are negated and AND-ed, so a
 * candidate matching *any* excluded term drops out even when it also matches
 * an included one. ``companies`` and ``universities`` carry their mode on each
 * entry instead, because a chip there also carries a scope and date window.
 */
export interface PipelineFilterSchema {
  names?: string[] | null;
  emails?: string[] | null;
  job_titles?: string[] | null;
  locations?: string[] | null;
  skills?: string[] | null;
  majors?: string[] | null;
  university_locations?: string[] | null;
  social_urls?: string[] | null;
  exclude_names?: string[] | null;
  exclude_emails?: string[] | null;
  exclude_job_titles?: string[] | null;
  exclude_locations?: string[] | null;
  exclude_skills?: string[] | null;
  exclude_majors?: string[] | null;
  exclude_university_locations?: string[] | null;
  exclude_social_urls?: string[] | null;
  companies?: PipelineEntityFilter[] | null;
  universities?: PipelineEntityFilter[] | null;
  min_degree?: PipelineFilterSchemaMinDegree;
  grad_year_start?: number | null;
  grad_year_end?: number | null;
  stages?: string[] | null;
  exclude_stages?: string[] | null;
  sequences?: string[] | null;
  exclude_sequences?: string[] | null;
  enrollment_statuses?: ('scheduled' | 'active' | 'paused' | 'completed' | 'cancelled' | 'bounced' | 'error')[] | null;
  origins?: ('sourced' | 'search' | 'ats' | 'profile_import' | 'upload_pdf' | 'upload_docx' | 'upload_rtf' | 'upload_txt' | 'upload_image' | 'upload_csv')[] | null;
  ats_sync_states?: ('not_synced' | 'queued' | 'synced' | 'error' | 'ineligible')[] | null;
  social_networks?: ('linkedin' | 'github' | 'twitter' | 'facebook')[] | null;
  exclude_social_networks?: ('linkedin' | 'github' | 'twitter' | 'facebook')[] | null;
  enrolled?: boolean | null;
  revealed?: boolean | null;
  has_email?: boolean | null;
  has_phone?: boolean | null;
  added_from?: string | null;
  added_to?: string | null;
  added_within?: PipelineFilterSchemaAddedWithin;
  in_stage_from?: string | null;
  in_stage_to?: string | null;
  in_stage_within?: PipelineFilterSchemaInStageWithin;
  min_experience_years?: number | null;
  max_experience_years?: number | null;
}
